import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: true,
  imports: [RouterLink, MatButtonModule],
})
export class NotFoundComponent {
  readonly title: string;
  readonly subtitle: string;

  constructor(route: ActivatedRoute) {
    const data = route.snapshot.data;
    this.title = data['title'] ?? "Ooops ! La page demandée n'a pas été trouvée.";
    this.subtitle = data['subtitle'] ?? '';
  }
}
